import axios from 'axios'

export const PAGE_SIZE = 50

export function errorMessage(err: unknown): string {
  if (axios.isAxiosError(err)) return err.response?.data?.error ?? err.message
  return err instanceof Error ? err.message : String(err)
}

const FIELD_LABELS: Record<string, string> = {
  categoryCode: 'TD SYNNEX category code',
  mediaType: 'media type',
  unspsc: 'UNSPSC code',
  cpuCode: 'Ingram CPU code',
  productGroupNumber: 'Ingram product group',
  vendorCode: 'Ingram vendor code',
  sin: 'Dell GSA SIN',
  skuPrefix: 'Dell SKU prefix',
  lob: 'Dell product line',
  skuType: 'Dell SKU type',
  discountCategory: 'Dell discount category',
  warrantyCode: 'Dell warranty code',
  productDescription: 'Dell product description',
  skuDescription: 'Dell SKU description',
  description: 'description',
  manufacturer: 'manufacturer',
  vendor: 'vendor',
}

export function fieldLabel(field: string): string {
  return field in FIELD_LABELS ? FIELD_LABELS[field] : field
}

export function describeRule(rule: {
  matchType: string
  matchField: string
  pattern: string
  scope: string
  priority: number
}): string {
  const field = fieldLabel(rule.matchField)
  const match =
    rule.matchType === 'REGEX'
      ? `Matches when the ${field} contains text matching "${rule.pattern}".`
      : rule.matchField === 'categoryCode'
      ? `Matches TD SYNNEX category codes starting with ${rule.pattern}.`
      : `Matches when the ${field} is ${rule.pattern}.`
  return `${match} Rules are checked lowest number first and the first match wins; this one is ${rule.priority}.`
}

export function describeScope(scope: string): string {
  const separator = scope.indexOf(':')
  if (separator < 0) return scope
  const field = scope.slice(0, separator)
  const value = scope.slice(separator + 1)
  return field === 'categoryCode'
    ? `Only for TD SYNNEX codes starting with ${value}`
    : `Only for products whose ${fieldLabel(field)} is ${value}`
}

export function formatPercent(value: number | null | undefined): string {
  return value === null || value === undefined ? '-' : `${Math.round(value * 100)}%`
}
